import { FC } from 'react';

import { FooterWithData } from '@telialt/core-footer/src';
import { useLayoutPath } from '@telialt/utils/src/useLayoutPath';

export const Footer: FC = () => {
    const path = useLayoutPath();

    return <FooterWithData path={path} />;
};
